import React from 'react';
import styles from './styles.scss';

const ListViewTwoRowHeader: React.FunctionComponent<{header: React.ReactNode, subheader: React.ReactNode}> = (props) => (
  <div className={styles.wrapper}>
    <span className={styles.header}>{props.header}</span>
    <span className={styles.subheader}>{props.subheader}</span>
  </div>
);

export default ListViewTwoRowHeader;
